
  import { Vue, Component, Prop } from "vue-property-decorator";
  import DropdownFilter from "@/components/filters/DropdownFilterNew.vue";
  import DropdownOption from "@/entities/DropdownOption";

  @Component({
    components: {
      DropdownFilter,
    },
  })
  export default class CurrencySelect extends Vue {
    @Prop({ default: "CAD", type: String}) value!: string;
    @Prop({ default: true, type: Boolean }) withBorder!: boolean;
     @Prop({ type: String, default: "" }) readonly getcontainerStyle?: string;

    get mappedValue(): DropdownOption[] {
      return [{ id: this.value, name: this.value }];
    }

    currencyOptions: DropdownOption[] = [
      { id: "USD", name: "USD" },
      { id: "CAD", name: "CAD" },
    ];

    handleInput(val: DropdownOption[]): void {
      if (!val.length) {
        return;
      }

      this.$emit("input", val[0].id);
    }
  }
